import { create } from "zustand";

const useTableCatalogItems = create((set) => ({
  tableCatalogItems: [],
  setTableCatalogItems: (tableCatalogItems) => set({ tableCatalogItems }),
}));

export default useTableCatalogItems;
